/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import {
  RadioGroup,
  Radio,
  Button,
  FormControlLabel,
  MenuItem,
  Select,
  setRef
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { ToastContainer, toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import {
  getAccountInfoData,
  modifyAccountInfoData,
  createAccountInfoData
} from "../modules/Auth/_redux/adminCrud";
import { GroupList } from "./GroupList";

const formatBytes = (bytes = 0, fixed) => {
  const marker = 1024; // Change to 1000 if required
  const decimal = fixed != null ? fixed : 2; // Change as required
  const kiloBytes = marker; // One Kilobyte is 1024 bytes
  const megaBytes = marker * marker; // One MB is 1024 KB
  const gigaBytes = marker * marker * marker; // One GB is 1024 MB
  // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

  // return bytes if less than a KB
  if (bytes == null || bytes < kiloBytes) {
    return `${bytes}B`;
    // return KB if less than a MB
  }
  if (bytes < megaBytes) {
    return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
    // return MB if less than a GB
  }
  if (bytes < gigaBytes) {
    return `${(bytes / megaBytes).toFixed(decimal)}MB`;
    // return GB if less than a TB
  }

  return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
};

export function AccountEdit(data) {
  const useStyles = makeStyles(theme => ({
    popLabelStyle: {
      display: "inline-block",
      //   marginTop: "-2px",
      textAlign: "left",
      fontSize: "1rem",
      width: "136px",
      height: "34px"
      //   borderRight: "1px solid #c8cace"
    },
    popInputSmallStyle: {
      display: "inline-block",
      marginLeft: "8px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "60px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputStyle: {
      display: "inline-block",
      marginTop: "-2px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "80px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    popInputLongStyle: {
      display: "inline-block",
      marginTop: "-2px",
      paddingLeft: "8px",
      fontSize: "1rem",
      width: "300px",
      height: "24px",
      borderRadius: "4px 4px 4px 4px",
      border: "1px solid #c8cace"
    },
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1rem",
      width: "160px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "24px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    treeContainerStyle: {
      display: "inline-block",
      width: "calc(20% - 12px)",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "80%",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#123456",
      border: "1px solid #123456",
      background: "rgb(213, 204, 232)"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid #c8cace",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },

    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    subTitlePopStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px"
    },
    subTitlePopLineStyle: {
      fontSize: "1rem",
      color: "#555555",
      margin: "4px",
      height: "32px"
      //   borderBottom: "1px solid #c8cace"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid #c8cace"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);

  const [userName, setUserName] = React.useState("");
  const [userId, setUserId] = React.useState("");
  // const [password, setPassword] = React.useState("12345678");
  const [tempPassword, setTempPassword] = React.useState("");
  const [tempPassword1, setTempPassword1] = React.useState("");

  const [showOrgList, setShowOrgList] = React.useState(false);
  const [showChangePassword, setShowChangePassword] = React.useState(false);
  const [tempGroupName, setTempGroupName] = React.useState("");
  const [tempGroupCode, setTempGroupCode] = React.useState("");
  const [groupName, setGroupName] = React.useState("");
  const [groupCode, setGroupCode] = React.useState("");

  const [zimbraMailQuota, setZimbraMailQuota] = React.useState(1024);
  const [
    zimbraMailAttachmentMaxSize,
    setZimbraMailAttachmentMaxSize
  ] = React.useState(256);

  const [enableMailQuota, setEnableMailQuota] = React.useState("TRUE");
  const [enableMaxSendAttachSize, setEnableMaxSendAttachSize] = React.useState(
    "TRUE"
  );

  const [
    zimbraFeatureAdminPreferencesEnabled,
    setZimbraFeatureAdminPreferencesEnabled
  ] = React.useState("FALSE");
  const [zimbraAccountStatus, setZimbraAccountStatus] = React.useState(
    "active"
  );
  const [quotaType, setQuotaType] = React.useState("P");
  const [createTime, setCreateTime] = React.useState("");
  const [lastLogonTime, setLastLogonTime] = React.useState("");
  const [groupList, setGroupList] = React.useState([1, 3]);

  const handlePressDeleteGroup = index => {
    groupList.splice(index, 1);
    setGroupList(groupList);
    setRefresh(!refresh);
  };
  const handleChangeEnableMailQuota = event => {
    setEnableMailQuota(event.target.value);
  };

  const handleChangeMaxSendAttachSize = event => {
    setEnableMaxSendAttachSize(event.target.value);
  };

  const handleChangeLevel = event => {
    setZimbraFeatureAdminPreferencesEnabled(event.target.value);
  };

  const handleChangeStatus = event => {
    setZimbraAccountStatus(event.target.value);
  };

  const handleChangeQuotaType = event => {
    console.log("QUOTA", event.target.value);
    setQuotaType(event.target.value);
  };

  const getAccountInfo = emailId => {
    setUserName(data.userData.name);
    setUserId(data.userData.userId);
    setTempGroupName(data.userData.groupName);
    setGroupName(data.userData.groupName);
    setGroupCode(data.userData.groupCode);

    getAccountInfoData(emailId).then(data => {
      if (data.data.accountInfo != null) {
        const accountInfo = data.data.accountInfo[0];

        const zimbraFeatureAdminPreferencesEnabled = accountInfo.a.filter(
          a => a.n === "zimbraFeatureAdminPreferencesEnabled"
        )[0]._content;

        const zimbraMailQuota = accountInfo.a.filter(
          a => a.n === "zimbraMailQuota"
        )[0]._content;
        const zimbraMailAttachmentMaxSize = accountInfo.a.filter(
          a => a.n === "zimbraMailAttachmentMaxSize"
        )[0]._content;

        const zimbraAccountStatus = accountInfo.a.filter(
          a => a.n === "zimbraAccountStatus"
        )[0]._content;

        // 20211205201624.074Z
        const zimbraCreateTimestamp = accountInfo.a.filter(
          a => a.n === "zimbraCreateTimestamp"
        )[0]._content;
        setCreateTime(
          zimbraCreateTimestamp.substr(0, 4) +
            "/" +
            zimbraCreateTimestamp.substr(4, 2) +
            "/" +
            zimbraCreateTimestamp.substr(6, 2) +
            " " +
            zimbraCreateTimestamp.substr(8, 2) +
            ":" +
            zimbraCreateTimestamp.substr(10, 2) +
            ":" +
            zimbraCreateTimestamp.substr(12, 2)
        );

        let zimbraLastLogonTimestamp = "";
        try {
          zimbraLastLogonTimestamp = accountInfo.a.filter(
            a => a.n === "zimbraLastLogonTimestamp"
          )[0]._content;
          setLastLogonTime(
            zimbraLastLogonTimestamp.substr(0, 4) +
              "/" +
              zimbraLastLogonTimestamp.substr(4, 2) +
              "/" +
              zimbraLastLogonTimestamp.substr(6, 2) +
              " " +
              zimbraLastLogonTimestamp.substr(8, 2) +
              ":" +
              zimbraLastLogonTimestamp.substr(10, 2) +
              ":" +
              zimbraLastLogonTimestamp.substr(12, 2)
          );
        } catch (err) {}

        console.log("zimbraMailQuota", zimbraMailQuota);
        console.log("zimbraMailAttachmentMaxSize", zimbraMailAttachmentMaxSize);
        console.log("zimbraAccountStatus", zimbraAccountStatus);
        console.log("zimbraLastLogonTimestamp", zimbraLastLogonTimestamp);
        console.log("zimbraCreateTimestamp", zimbraCreateTimestamp);

        setZimbraMailQuota(parseInt(zimbraMailQuota, 10) / 1024 / 1024);
        setZimbraAccountStatus(zimbraAccountStatus);
        setZimbraMailAttachmentMaxSize(
          parseInt(zimbraMailAttachmentMaxSize, 10) / 1024 / 1024
        );

        if (parseInt(zimbraMailQuota, 10) === 0) setEnableMailQuota("FALSE");
        else setEnableMailQuota("TRUE");

        if (parseInt(zimbraMailAttachmentMaxSize, 10) === 0)
          setEnableMaxSendAttachSize("FALSE");
        else setEnableMaxSendAttachSize("TRUE");

        setQuotaType(data.data.quotaType);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const makeParams = () => {
    let params = [
      { name: "zimbraAccountStatus", value: zimbraAccountStatus },
      {
        name: "zimbraFeatureAdminPreferencesEnabled",
        value: zimbraFeatureAdminPreferencesEnabled
      },
      {
        name: "zimbraMailAttachmentMaxSize",
        value:
          enableMaxSendAttachSize === "TRUE"
            ? parseInt(zimbraMailAttachmentMaxSize, 10) * 1024 * 1024
            : 0
      },
      {
        name: "zimbraMailQuota",
        value:
          enableMailQuota === "TRUE"
            ? parseInt(zimbraMailQuota, 10) * 1024 * 1024
            : 0
      }
    ];

    return params;
  };

  const modifyAccountInfo = () => {
    let params = makeParams();

    console.log("modifyAccountInfo", params);
    let pwd = null;
    if (tempPassword !== "" && tempPassword != null) pwd = tempPassword;

    modifyAccountInfoData(
      data.userData.email,
      pwd,
      params,
      groupCode,
      groupName,
      quotaType
    ).then(result => {
      data.onApply();
    })
    .catch(error => {
      console.log(error)
    })
  };

  const createAccountInfo = () => {
    let params = makeParams();

    if (!checkSavable()) return;

    if (userName == null || userName === "") {
      toast("사용자 이름을 입력하세요.");
      return;
    }

    if (groupCode == null || groupCode === "") {
      toast("메일 그룹을 선택하세요.");
      return;
    }

    console.log("createAccountInfo", params);

    let pwd = null;
    if (tempPassword !== "" && tempPassword != null) pwd = tempPassword;

    createAccountInfoData(
      userName,
      userId + "@brainary.io",
      pwd,
      groupCode,
      groupName,
      params,
      quotaType
    ).then(result => {
      console.log("RESULT", result);
      if (result.code === 200) {
        data.onApply();
      } else toast("이미 존재하는 메일 아이디 입니다.");
    })
    .catch(error => {
      console.log(error)
    })
  };

  const checkPassword = () => {
    return (
      tempPassword.length >= 8 &&
      tempPassword1.length >= 8 &&
      tempPassword === tempPassword1
    );
  };

  const checkSavable = () => {
    const bPassword =
      tempPassword.length >= 8 &&
      tempPassword1.length >= 8 &&
      tempPassword === tempPassword1;
    return bPassword && userId.length > 4 && userName.length > 0;
  };

  useEffect(() => {
    console.log("AccountEdit", data);

    if (data.mode === "MODIFY") getAccountInfo(data.userData.email);
  }, []);

  useEffect(() => {}, [refresh, zimbraAccountStatus, zimbraMailQuota]);

  return (
    <>
      <ToastContainer />
      <DialogTitle id="alert-dialog-title" style={{ paddingBottom: "0px" }}>
        {data.mode === "NEW" ? "계정 추가" : "계정 수정"}
      </DialogTitle>
      <DialogContent
        style={{
          height: "480px"
        }}
      >
        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>아이디<span style={{ color: "red" }}>*</span></div>

          <input
            type="text"
            disabled={data.mode === "MODIFY"}
            value={userId}
            placeholder="4자 이상"
            className={Styles.popInputLongStyle}
            onChange={e => {
              setUserId(e.target.value);
            }}
          />
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>
            이름<span style={{ color: "red" }}>*</span>
          </div>
          <input
            type="text"
            disabled={data.mode === "MODIFY"}
            value={userName}
            className={Styles.popInputLongStyle}
            onChange={e => {
              setUserName(e.target.value);
            }}
          />
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>비밀번호</div>
          <Button
            className={Styles.buttonSmallStyle}
            style={{ height: "21px" }}
            onClick={() => {
              setShowChangePassword(true);
            }}
          >
            변경
          </Button>
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>
            그룹선택<span style={{ color: "red" }}>*</span>
          </div>
          <div
            style={{
              display: "inline-block",
              paddingRight: `${tempGroupName?.length > 0 ? "12px" : "0px"}`
            }}
          >
            {tempGroupName}
          </div>
          <Button
            className={Styles.buttonSmallStyle}
            style={{ height: "21px" }}
            onClick={() => {
              // setShowGroup(false);
              setShowOrgList(true);
            }}
          >
            {data.mode === "NEW" ? "선택" : "변경"}
          </Button>
        </div>

        {/* <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>사용자 디렉토리</div>
          <input
            type="text"
            value={userName}
            className={Styles.popInputLongStyle}
            onChange={e => {
              setUserName(e.target.value);
            }}
          />
        </div> */}

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>권한</div>

          <RadioGroup
            label="사용함"
            name="gender1"
            style={{
              display: "inline-block",
              fontSize: "1.2rem",
              height: "34px",
              marginTop: "-7px"
            }}
            value={zimbraFeatureAdminPreferencesEnabled}
            onChange={handleChangeLevel}
          >
            <FormControlLabel
              value="FALSE"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="일반"
            />
            {/* <FormControlLabel
              value="DOMAIN"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="서버운영자"
            /> */}
            <FormControlLabel
              value="TRUE"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="도메인운영자"
            />
          </RadioGroup>
        </div>

        <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
          <div className={Styles.popLabelStyle}>사용자 상태</div>

          <RadioGroup
            label="사용함"
            name="gender1"
            style={{
              display: "inline-block",
              fontSize: "1.2rem",
              height: "34px",
              marginTop: "-7px"
            }}
            value={zimbraAccountStatus}
            onChange={handleChangeStatus}
          >
            <FormControlLabel
              value="active"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="활성"
            />
            <FormControlLabel
              value="maintenance"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="비활성"
            />
          </RadioGroup>
        </div>

        {data.mode === "MODIFY" && (
          <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
            <div className={Styles.popLabelStyle}>사용량</div>
            <span style={{ fontWeight: "bold" }}>메일</span>{" "}
            {data.userData.mailQuota}
            {/* | <span style={{ fontWeight: "bold" }}>파일함</span> 1.35MB / 무제한(
          -%) */}
          </div>
        )}

        <div
          className={Styles.subTitlePopStyle}
          style={{ height: "24px", marginTop: "8px" }}
        >
          <div className={Styles.popLabelStyle}>
            용량 제한
            {/* <span style={{ color: "red" }}> *</span> */}
          </div>

          <RadioGroup
            label="사용함"
            name="gender1"
            style={{
              display: "inline-block",
              fontSize: "1.2rem",
              height: "34px",
              marginTop: "-7px"
            }}
            value={quotaType}
            onChange={handleChangeQuotaType}
          >
            <FormControlLabel
              value="G"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="그룹권한"
            />
            <FormControlLabel
              value="P"
              style={{
                marginTop: "4px",
                // marginLeft: "12px",
                height: "24px",
                fontSize: "1.2rem"
              }}
              control={<Radio />}
              label="개인권한 적용"
            />
          </RadioGroup>
        </div>

        {quotaType === "P" && (
          <>
            <div
              className={Styles.dataRowStyle}
              style={{
                borderTop: "1px solid #c8cace",
                height: "34px",
                lineHeight: "34px",
                paddingLeft: "5px"
              }}
            >
              <div className={[Styles.popLabelStyle]}>메일함 저장공간</div>
              <div
                className={[Styles.dataColStyle]}
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  textAlign: "left",
                  paddingLeft: "12px",
                  width: "276px"
                }}
              >
                <RadioGroup
                  label="사용함"
                  name="gender1"
                  style={{
                    display: "inline-block",
                    fontSize: "1.2rem",
                    height: "34px",
                    marginTop: "-7px"
                  }}
                  value={enableMailQuota}
                  onChange={handleChangeEnableMailQuota}
                >
                  <FormControlLabel
                    value="TRUE"
                    style={{
                      marginTop: "4px",
                      marginRight: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label=""
                  />
                  <input
                    type="text"
                    value={zimbraMailQuota}
                    style={{ marginLeft: "-14px" }}
                    className={Styles.popInputSmallStyle}
                    onChange={e => {
                      setZimbraMailQuota(e.target.value);
                    }}
                  />{" "}
                  MB
                  <FormControlLabel
                    value="FALSE"
                    style={{
                      marginTop: "4px",
                      marginLeft: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label="무제한"
                  />
                </RadioGroup>
              </div>
            </div>

            <div
              className={Styles.dataRowStyle}
              style={{ height: "34px", lineHeight: "34px", paddingLeft: "5px" }}
            >
              <div className={[Styles.popLabelStyle]}>
                송신메일 첨부 크기 제한
              </div>
              <div
                className={[Styles.dataColStyle]}
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  textAlign: "left",
                  paddingLeft: "12px",
                  width: "276px"
                }}
              >
                <RadioGroup
                  label="사용함"
                  name="gender1"
                  style={{
                    display: "inline-block",
                    fontSize: "1.2rem",
                    height: "34px",
                    marginTop: "-7px"
                  }}
                  value={enableMaxSendAttachSize}
                  onChange={handleChangeMaxSendAttachSize}
                >
                  <FormControlLabel
                    value="TRUE"
                    style={{
                      marginTop: "4px",
                      marginRight: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label=""
                  />
                  <input
                    type="text"
                    value={zimbraMailAttachmentMaxSize}
                    style={{ marginLeft: "-14px" }}
                    className={Styles.popInputSmallStyle}
                    onChange={e => {
                      setZimbraMailAttachmentMaxSize(e.target.value);
                    }}
                  />{" "}
                  MB
                  <FormControlLabel
                    value="FALSE"
                    style={{
                      marginTop: "4px",
                      marginLeft: "12px",
                      fontSize: "1.2rem"
                    }}
                    control={<Radio />}
                    label="무제한"
                  />
                </RadioGroup>
              </div>
            </div>
          </>
        )}

        {data.mode === "MODIFY" && (
          <div className={Styles.subTitlePopStyle} style={{ height: "24px" }}>
            <div
              className={Styles.popLabelStyle}
              style={{ paddingTop: "10px" }}
            >
              로그인 정보
            </div>
            <div
              className={Styles.dataRowStyle}
              style={{
                borderTop: "1px solid #c8cace",
                height: "34px",
                lineHeight: "34px"
                // paddingLeft: "5px"
              }}
            >
              <div className={[Styles.popLabelStyle]}>계정 등록일</div>
              <div
                // className={[Styles.dataColStyle]}
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  paddingLeft: "12px"
                }}
              >
                {createTime}
              </div>
            </div>

            <div
              className={Styles.dataRowStyle}
              style={{
                // borderTop: "1px solid #c8cace",
                height: "34px",
                lineHeight: "34px"
                // paddingLeft: "5px"
              }}
            >
              <div className={[Styles.popLabelStyle]}>최종 로그인</div>
              <div
                style={{
                  borderLeft: "1px solid #c8cace",
                  height: "34px",
                  paddingLeft: "12px"
                }}
              >
                {lastLogonTime}
              </div>
            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            paddingBottom: "8px"
          }}
        >
          <Button
            className={Styles.buttonSmallStyle}
            onClick={() => {
              // setShowAccount(false);
              data.onCancel();
            }}
          >
            취소
          </Button>
          <Button
            style={{ marginLeft: "24px" }}
            className={[
              Styles.buttonSmallStyle,
              data.mode === "NEW" &&
                !checkSavable() &&
                Styles.buttonDisableStyle


            ]}
            autoFocus
            onClick={() => {
              // setShowAccount(false);
              // data.onApply();

              if (data.mode === "MODIFY") modifyAccountInfo();
              else createAccountInfo();
            }}
          >
            저장
          </Button>
        </div>
      </DialogActions>

      <Dialog
        open={showOrgList}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          style={{
            width: "400px"
          }}
        >
          <GroupList
            onClick={group => {
              setTempGroupName(group.groupName);
              setTempGroupCode(group.groupCode);
            }}
          />
        </div>
        <DialogActions>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "8px"
            }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setShowOrgList(false);
              }}
            >
              취소
            </Button>
            <Button
              style={{ marginLeft: "24px" }}
              className={[Styles.buttonSmallStyle]}
              autoFocus
              onClick={() => {
                setGroupName(tempGroupName);
                setGroupCode(tempGroupCode);
                setRefresh(!refresh);
                setShowOrgList(false);
              }}
            >
              저장
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showChangePassword}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">비밀번호 설정</DialogTitle>
        <DialogContent>
          <div>
            <input
              type="password"
              placeholder="비밀번호 (8자 이상)"
              value={tempPassword}
              className={Styles.popInputLongStyle}
              onChange={e => {
                console.log("PASSWORD", e.target.value);
                setTempPassword(e.target.value);
              }}
            ></input>
          </div>
          <div style={{marginTop: "12px"}}>
            <input
              type="password"
              placeholder="비밀번호 확인 (8자 이상)"
              value={tempPassword1}
              className={Styles.popInputLongStyle}
              onChange={e => {
                console.log("PASSWORD1", e.target.value);
                setTempPassword1(e.target.value);
              }}
            ></input>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingTop: "16px",
              paddingBottom: "8px"
            }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setTempPassword("");
                setTempPassword1("");
                setShowChangePassword(false);
              }}
            >
              취소
            </Button>
            <Button
              className={[
                Styles.buttonSmallStyle
                // !checkIpAddress() && Styles.buttonDisableStyle
              ]}
              style={{
                marginLeft: "24px",
                background: `${!checkPassword() ? "#d5cce8" : "unset"}`
              }}
              autoFocus
              onClick={() => {
                // handlePressSave();
                if(!checkPassword()) {
                  toast('비밀번호를 확인해 주세요.')
                  return;
                }
                setShowChangePassword(false);
              }}
            >
              확인
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
